function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.85937 25.4658C1.85937 12.211 12.6045 1.46581 25.8594 1.46581C39.1142 1.46582 49.8594 12.211 49.8594 25.4658C49.8594 38.7207 39.1142 49.4658 25.8594 49.4658C12.6045 49.4658 1.85937 38.7206 1.85937 25.4658Z",
  stroke: "#925EF4",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8398 34.2869C32.8398 35.8266 31.1731 36.7888 29.8397 36.0189L14.5637 27.1982C13.2305 26.4284 13.2305 24.504 14.5637 23.7342L29.8397 14.9135C31.1731 14.1436 32.8398 15.1058 32.8398 16.6455L32.8398 34.2869Z",
  stroke: "#925EF4",
  strokeWidth: 2
});
function SvgButtonLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLeft);
export default __webpack_public_path__ + "static/media/buttonLeft.48f712d2c14074efad9e726cafcd0d39.svg";
export { ForwardRef as ReactComponent };